import { render } from "./NeumorphismButton.vue?vue&type=template&id=650a375e&scoped=true"
import script from "./NeumorphismButton.vue?vue&type=script&lang=js"
export * from "./NeumorphismButton.vue?vue&type=script&lang=js"

import "./NeumorphismButton.vue?vue&type=style&index=0&id=650a375e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650a375e"]])

export default __exports__